import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import './LatestArtistPosts.css';
import ProfielPicture from './ProfilePicture'

const GET_LATEST_POSTS = gql`
  query LatestArtistPosts($limit: Int) {
    latestArtistPosts(limit: $limit) {
      id
      content
      images
      createdAt
      artistPage {
        id
        title
        profileImage
        
      }
    }
  }
`;

const LatestArtistPosts = () => {
  const navigate = useNavigate();
  const { data, loading, error } = useQuery(GET_LATEST_POSTS, {
    variables: { limit: 10 },
    fetchPolicy: 'network-only',
  });

  if (loading) return <p className="latest-posts-loading">Loading latest posts...</p>;
  if (error) return <p className="latest-posts-error">Error: {error.message}</p>;

  return (
    <div className="latest-posts-container">
        <h3>Latest Posts</h3>
      {data.latestArtistPosts.map((post) => (
        <div
          className="post-card"
          key={post.id}
          onClick={() => navigate(`/artist/${post.artistPage.id}`)}
        >
          
          <ProfielPicture profileImage = {post.artistPage.profileImage} size = {60}/>
          <div className="post-details">
            <h4>{post.artistPage.title}</h4>
            <p>{post.content.slice(0, 120)}...</p>
            
            {Array.isArray(post.images) && post.images.length > 0 && post.images.map((img, i) => (
  <img key={i} src={img} alt={`Post ${i + 1}`} className="post-image" />
))}

          </div>
        </div>
      ))}
    </div>
  );
};

export default LatestArtistPosts;
